// src/components/Login.jsx

import React, { useState } from 'react';
import { LogIn } from 'lucide-react';
import { servicioAuth } from '../services/firebaseService';
import logoLiceo from '../assets/logo-liceo.png';

const Login = ({ usuario, onLoginExito }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);

    try {
      await servicioAuth.login(email, password);
      setEmail('');
      setPassword('');
      onLoginExito();
    } catch (err) {
      setError('Error: ' + err.message);
    } finally {
      setCargando(false);
    }
  };

  // Si el usuario está autenticado
  if (usuario) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Bienvenido</h2>
          <p className="text-gray-600">{usuario.email}</p>
        </div>
      </div>
    );
  }

  // Formulario de login/registro
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl p-6 max-w-sm w-full">
        {/* Header */}
        <div className="text-center mb-5">
          <img 
            src={logoLiceo} 
            alt="Logo Liceo Ángel Emilio Casado" 
            className="w-14 h-14 object-contain mx-auto mb-2"
          />
          <h1 className="text-2xl font-bold text-gray-800">Liceo Ángel Emio Casado</h1>
          <h2 className="text-1xl font-bold text-blue-600">Gestor de Actividades</h2>
          <p className="text-gray-600 text-xs mt-1">Si no tiene acceso a la plataforma, favor comunicarse con el administrador del sistema.</p>
        </div>

        {/* Formulario - Solo Login */}
        <form onSubmit={handleLogin}>
          {/* Email */}
          <div className="mb-3">
            <label htmlFor="email" className="block text-xs font-semibold text-gray-700 mb-1">
              Correo Electrónico
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              required
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Password */}
          <div className="mb-3">
            <label htmlFor="password" className="block text-xs font-semibold text-gray-700 mb-1">
              Contraseña
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Error */}
          {error && (
            <div className="mb-3 p-2 rounded-lg text-xs font-semibold bg-red-100 text-red-800">
              {error}
            </div>
          )}

          {/* Botón */}
          <button
            type="submit"
            disabled={cargando}
            className="w-full py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition font-semibold disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {cargando ? 'Iniciando...' : 'Iniciar Sesión'}
          </button>
        </form>

        {/* Footer */}
        <div className="mt-5 text-center text-xs text-gray-500 space-y-0.5">
          <p>© Liceo Ángel Emilio Casado</p>
          <p className="text-gray-400">Desarrollado por: Ister Melo</p>
	<p className="text-gray-400">Versión diciembre 2025</p>	
        </div>
      </div>
    </div>
  );
};

export default Login;
